var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-menu",
    { staticClass: "navbar", attrs: { mode: "horizontal" } },
    [
      _c("div", { staticClass: "logo" }, [
        _c("img", { staticClass: "user-avatar", attrs: { src: _vm.logoHzqf } }),
        _vm._v("衡州企服运营后台 "),
      ]),
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { toggleClick: _vm.toggleSideBar, isActive: _vm.sidebar.opened },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showfullScreenState,
              expression: "showfullScreenState",
            },
          ],
          staticClass: "nav-fullScreen-tab",
        },
        [
          _c(
            "div",
            {
              class: [
                "tab-item",
                _vm.selectTab == "platform" ? "select_tab" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange("platform")
                },
              },
            },
            [_vm._v(" 平台统计 ")]
          ),
          _c(
            "div",
            {
              class: [
                "tab-item",
                _vm.selectTab == "monitor" ? "select_tab" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange("monitor")
                },
              },
            },
            [_vm._v(" 企业监测 ")]
          ),
          _c(
            "div",
            {
              class: [
                "tab-item",
                _vm.selectTab == "enterprise" ? "select_tab" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange("enterprise")
                },
              },
            },
            [_vm._v(" 企业统计 ")]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showfullScreenState,
              expression: "showfullScreenState",
            },
          ],
          staticClass: "nav-fullScreen",
        },
        [
          _vm.selectTab == "monitor"
            ? _c(
                "el-select",
                {
                  staticClass: "customSelect",
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    filterable: "",
                    placeholder: "请选择月份",
                    size: "mini",
                  },
                  on: { change: _vm.handleMonthChange },
                  model: {
                    value: _vm.monthValue,
                    callback: function ($$v) {
                      _vm.monthValue = $$v
                    },
                    expression: "monthValue",
                  },
                },
                _vm._l(_vm.monthOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dropdown",
        {
          staticClass: "avatar-container",
          attrs: { trigger: "click" },
          on: { command: _vm.handleCommand },
        },
        [
          _c(
            "div",
            { staticClass: "avatar-wrapper" },
            [
              _vm._v(" 欢迎您， " + _vm._s(_vm.name) + " "),
              _c("el-badge", {
                staticClass: "mark",
                attrs: { value: _vm.msgcount },
              }),
              _c("i", { staticClass: "el-icon-caret-bottom" }),
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "user-dropdown",
              attrs: { slot: "dropdown" },
              slot: "dropdown",
            },
            [
              _c(
                "el-dropdown-item",
                { attrs: { command: "handleGoProfile" } },
                [_c("span", [_vm._v("个人中心")])]
              ),
              _c("el-dropdown-item", [
                _c(
                  "span",
                  [
                    _vm._v("切换主题 "),
                    _c("el-switch", {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      model: {
                        value: _vm.theme,
                        callback: function ($$v) {
                          _vm.theme = $$v
                        },
                        expression: "theme",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-dropdown-item",
                { attrs: { command: "logout", divided: "" } },
                [_c("span", [_vm._v("退出")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }